import { Flatfile } from '@flatfile/api-internal'
import { Button, IconName, Text, cn } from '@flatfile/baseline'
import { NavLink, useLocation } from 'react-router-dom'
import { useIdentity } from '../../hooks/useIdentity'
import UpdateAppModal from '../../pages/CustomApps/CustomAppModal'
import useResource from '../../resources/hooks/useResource'
import { getNavigationPath } from '../Apps/AppCTAs'
import { AppSwitcher } from './AppSwitcher'

export const CustomAppLink = ({
  app,
  open,
  platformApps,
  customApps,
  demoApps,
}: {
  app: Flatfile.App
  open?: boolean
  platformApps: Array<{
    label: string
    icon: string
    action?: string
  }>
  customApps: Array<{
    id: string
    name: string
    icon?: string
    activatedAt?: string
  }>
  demoApps: Array<{
    id: string
    name: string
    icon?: string
    activatedAt?: string
  }>
}) => {
  const { id } = app
  const resource = useResource('APPS', id)
  const { identity, hasPermission } = useIdentity()
  const location = useLocation()

  if (!resource) {
    return <></>
  }
  const setupPath = getNavigationPath(resource)
  return (
    <div key={resource.id} className='px-0' hidden={!open}>
      <div className='flex justify-between items-center px-0 pt-3'>
        <AppSwitcher
          platformApps={platformApps}
          customApps={customApps}
          demoApps={demoApps}
          name={resource.name}
          icon={(resource.icon as IconName) || 'app'}
        />
        {hasPermission({ resource: identity.account, permissionKey: 'app:update' }) && (
          <UpdateAppModal currentApp={resource} isBuiltInApp />
        )}
      </div>
      <div>
        {!resource ||
          (!resource.activatedAt && (
            <NavLink to={setupPath} relative='path'>
              <Button
                variant='ghost'
                className={cn(
                  'w-[calc(100%+0.75rem)] justify-start p-1.5 -ml-1.5 mr-0 hover:bg-interactive-state-selected-enabled',
                  location.pathname === setupPath && 'text-primary font-medium '
                )}
                icon='numbered-list'
              >
                <Text variant='body'>{setupPath.includes('build') ? 'Finish setup' : 'Setup Guide'}</Text>
              </Button>
            </NavLink>
          ))}
        <NavLink to={`/apps/custom/${resource.id}/list/`} relative='path'>
          <Button
            variant='ghost'
            className={cn(
              'w-[calc(100%+0.75rem)] justify-start p-1.5 -ml-1.5 mr-0 hover:bg-interactive-state-selected-enabled',
              location.pathname === `/apps/custom/${resource.id}/list/` && 'text-primary font-medium '
            )}
            icon='clipboard-2'
          >
            <Text variant='body' className='text-primary'>
              Recent {resource.entityPlural}
            </Text>
          </Button>
        </NavLink>
      </div>
    </div>
  )
}
